import Vue from 'vue';

import {preDecimal, afterDecimal, formatPrice} from "./price";

Vue.filter('brku_price_pre_decimal', preDecimal);
Vue.filter('brku_price_after_decimal', afterDecimal);
Vue.filter('brku_format_price', formatPrice);